angular.module('mercury.services.companyChange')
.factory('companyChange', ["$state", "$rootScope", "multisite", "userinfo", "applicationMenu", function($state, $rootScope, multisite, userinfo, applicationMenu) {
      function _changeCompany(newCompany, event, navigateTo) {
        if (multisite.isMultisiteEnabled()) {
          if (event !== null) {
            event.stopPropagation();
          }
          multisite.disableCompany(company.id);

          newCompany.multisiteDisabled = multisite.isCompanyDisabled(newCompany.id);
        } else {
          if (newCompany.id == userinfo.activeCompany()) {
            if (!navigateTo) {
              return;
            }
            $state.go(navigateTo, {}, {reload: true});
          }

          userinfo.activeCompany(newCompany.id);

          // To avoid a user very quickly changing to another company while
          // we're still loading menus we only navigate once we know the
          // company they've just made active definitely has a menu available.
          applicationMenu.getMenu().then(function() {
            // Reload the current page with the new company
            $state.go(navigateTo || $state.current, {}, {reload: true});
            $rootScope.$broadcast('companyChanged');
          });
        }
      }
      function changeCompanyAndRefresh(newCompany, event) {
        return _changeCompany(newCompany, event);
      }
      function changeCompanyAndNavigate(newCompany, navigateTo) {
        return _changeCompany(newCompany, null, navigateTo);
      }
      return {
        changeCompanyAndRefresh: changeCompanyAndRefresh,
        changeCompanyAndNavigate: changeCompanyAndNavigate
      };
    }]);
